import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getLatestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = getLatestUpdates();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            刚刚更新的漫画章节
          </p>
        </div>
        <Link
          to="/category/action"
          className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
        {latest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}